import { BodyText } from 'styling/Typography'
import { GlobalViewFilterContainer } from './GlobalView.styled'
import { Flex, ThinSeparator } from 'styling/GlobalStyles'
import { ToggleButton } from 'components/Input/ToggleButton'
import { IGlobalViewFitlers } from 'types/global-view.interface'

export const GlobalViewFilter = ({ filter, handleToggle }: IGlobalViewFilter) => {
    return <GlobalViewFilterContainer open={filter.open}>
        <Flex center between >
            <BodyText weight='bold' >Filters</BodyText>
            {/* <BodyText color='#ff9900' >Save</BodyText> */}
        </Flex>
        <ThinSeparator />
        <Flex column gap='10px'>
            <Flex center between >
                <BodyText >Machines</BodyText>
                <ToggleButton state={filter.machines} handleChange={() => handleToggle('machines')} />
            </Flex>
            <Flex center between >
                <BodyText >Employees</BodyText>
                <ToggleButton state={filter.users} handleChange={() => handleToggle('users')} />
            </Flex>
            <Flex center between >
                <BodyText >Areas</BodyText>
                <ToggleButton state={filter.areas} handleChange={() => handleToggle('areas')} />
            </Flex>
        </Flex>

    </GlobalViewFilterContainer>
}

interface IGlobalViewFilter {
    filter: IGlobalViewFitlers
    handleToggle: (property: 'areas' | 'machines' | 'users') => Promise<void>
}